<template>
  <header
    id="main-header"
    class="main-header js-main-header"
    :style="{ 'background-image': `url(${headerBg})` }"
  >
    <Container>
      <div class="header-wrap">
        <router-link
          to="/"
          class="main-header__logo"
          :class="{ minidayz: logo.type === 'minidayz' }"
        >
          <img :src="logo.url" :alt="logo.alt" />
        </router-link>
      </div>
    </Container>
  </header>
</template>

<script>
import Container from "../common/Container";
import Account from "../Header/Account";

export default {
  components: {
    Container,
    Account
  },
  props: {
    logo: Object,
    headerBg: String,
    user: {}
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/vars";
@import "../../assets/styles/mixins";

.main-header {
  position: relative;
  min-height: 160px;
  background: #332e31 fixed top center;

  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    background-attachment: scroll;
  }

  @media (max-width: $screen-xl) {
    min-height: 100px;
  }

  @media (max-width: $screen-sm-max) {
    min-height: $navSizeSm;
    background-image: none !important;
  }

  @media (max-width: $screen-md) {
    display: none;
  }
}

.header-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.main-header__logo {
  display: inline-block;
  line-height: 160px;
  height: 160px;

  img {
    margin-top: -7px;
    width: 230px;
    vertical-align: middle;
    border: 0;
  }

  @media (max-width: $screen-xl) {
    line-height: 100px;
    height: 100px;

    img {
      margin-top: 0;
      width: 160px;
    }
  }

  &.minidayz {
    img {
      width: 320px;
    }

    @media (max-width: $screen-xl) {
      img {
        width: 200px;
      }
    }
  }
}
</style>
